<h3>CHASE DETAILS: <span class="header--accent">{{ chaseId }}</span></h3>
<div class="item-container"> 
  <app-list [items]="memberItems"></app-list>
</div>